// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2w7D7","dragIcon":"Choice_dragIcon__1cUI2","left":"Choice_left__2phL-","input":"Choice_input__33HW3"};